module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Nova frequência'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Frequência retroativa"
    },
    model: {
      value: (_vm.frequenciaRetroativa),
      callback: function($$v) {
        _vm.frequenciaRetroativa = $$v
      },
      expression: "frequenciaRetroativa"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ano",
      "type": "number",
      "disabled": !_vm.frequenciaRetroativa,
      "required": "",
      "rules": _vm.anoRules
    },
    model: {
      value: (_vm.frequencia.ano),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "ano", $$v)
      },
      expression: "frequencia.ano"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Mês",
      "items": _vm.listaMeses,
      "item-text": "nome",
      "item-value": "valor",
      "prepend-icon": "dashboard",
      "disabled": !_vm.frequenciaRetroativa,
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.mes),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "mes", $$v)
      },
      expression: "frequencia.mes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Observação",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.observacao),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "observacao", $$v)
      },
      expression: "frequencia.observacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atividades realizadas pelo bolsista",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.atividadesRealizadas),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "atividadesRealizadas", $$v)
      },
      expression: "frequencia.atividadesRealizadas"
    }
  })], 1)], 1), _vm._v(" "), (_vm.frequenciaRetroativa) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Justificativa para o atraso",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.justificativa),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "justificativa", $$v)
      },
      expression: "frequencia.justificativa"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.frequenciaRetroativa) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "black--text text-justify text-h6",
    staticStyle: {
      "margin-left": "-10px"
    }
  }, [_vm._v("\n                  Obs.: A confirmação da frequência retroativa depende de homologação da administração.\n                  "), _c('br'), _c('br')])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarFrequencia
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c3d168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/frequencia/criar-frequencia.vue
// module id = 784
// module chunks = 0